import { IconSearch } from "@tabler/icons-react";

type Props = {
  selectOptions?: any;
  name?: string;
  opt?: string;
  className?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};
export default function NormalSearch(props: Props) {
  return (
    <div
      className={`border border-gray-300 bg-white flex items-center rounded-full p-1 px-3 space-x-4 justify-between ${props.className} `}
    >
      <input
        className="text-sm placeholder:text-gray-600 focus:outline-none text-black font-medium placeholder:font-light w-full py-1"
        placeholder={props.name ? props.name : "Search here..."}
        value={props?.value}
        onChange={props?.onChange}
      />
      <IconSearch size={18} stroke={1.5}/>
    </div>
  );
}
